// Конфигурация окружения приложения: телеметрия и локаль.
export const SENTRY_ENV = window.SENTRY_ENV || import.meta.env.VITE_SENTRY_ENV
export const SENTRY_DSN = window.SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN
export const YANDEX_METRIKA_ID
  = window.YANDEX_METRIKA_ID || import.meta.env.VITE_YANDEX_METRIKA_ID
export const AMPLITUDE_KEY = window.AMPLITUDE_KEY || import.meta.env.VITE_AMPLITUDE_KEY
export const DEFAULT_LOCALE = 'ru-ru'
